export default __webpack_public_path__ + "static/media/63.46c439f7.png";